import React from 'react';
import Select from 'react-select';
import { placeholderStyle } from '../../AddSegment/Condition/Condition.constants';
import {
  MultiValueLabel,
  MultiValueRemove,
} from '../../AddSegment/components/labels';
import styles from '../Contacts.module.scss';
import { SOURCES } from './data';

const Sources = ({ sources, setSources }) => (
  <div className={styles.filter_row}>
    <span className={styles.label}>Sources</span>
    <Select
      styles={{
        ...placeholderStyle,
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
      components={{
        // eslint-disable-next-line react/no-unstable-nested-components
        MultiValueRemove: (props) => (
          <MultiValueRemove props={props} show="label" />
        ),
        // eslint-disable-next-line react/no-unstable-nested-components
        MultiValueLabel: (props) => (
          <MultiValueLabel props={props} show="label" />
        ),
      }}
      className="w-100"
      placeholder="Select..."
      onChange={(options) => {
        setSources(options);
      }}
      value={sources}
      options={SOURCES}
      isMulti
      menuPortalTarget={document.body}
    />
  </div>
);

export default Sources;
